module.exports = __webpack_public_path__ + "img/livingWitness_camera.a779caf2.png";